import tenantTheme from '@theme';
import React from 'react';
import Styled from 'styled-components';
import { Modal } from '../modals/antd-modals';
import { v2Color } from '@theme/v2';

export const IntroModal = Styled((props) => <Modal {...props} />)`
 .ant-modal-content {
   
    .ant-modal-header{
     padding: 0;
     padding-top: 45px;
      background: linear-gradient(178.74deg, ${v2Color('#F2FAFA')} 27.98%, ${v2Color('#C7FFFF')} 86.14%);
    }
  }

`;
